import { Box, Text } from "@nulogy/components";
import React from "react";

export default function FilterLabel({ value, marginTop = "x3", marginBottom = "x1" }) {
  return (
    <Box marginBottom={marginBottom} marginTop={marginTop}>
      <Text fontSize="small" fontWeight="bold">
        {value}
      </Text>
    </Box>
  );
}
